import { number, object, string } from '@gogame/schemas';

import { REVIEW_MARK, REVIEW_TEXT } from './constants';

export const ReviewsSchema = object({
  [REVIEW_MARK]: number().nullable().required('Rating is required'),
  [REVIEW_TEXT]: string().required('Review text is required'),
});
